import type { ResponseResult } from '@/core/http/response-result'
import type { AuthUser } from '../../domains/auth_user'
import type { AuthPort } from '../ports/auth_port'
import type { ApiError } from '@/core/http/response_error'

export class MeUseCase {
  private authPort: AuthPort

  constructor(authPort: AuthPort) {
    this.authPort = authPort
  }

  async execute(token: string): Promise<ResponseResult<AuthUser>> {
    try {
      const result = await this.authPort.me(token)
      return result
    } catch (error) {
      const _error: ApiError = error as ApiError
      return {
        STATUS_CODE: 2,
        ERROR: _error,
      }
    }
  }
}
